import { createFileRoute, redirect } from "@tanstack/react-router";

// Default /app route — redirect to clients as the main dashboard view
export const Route = createFileRoute("/app/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/clients" });
  },
  component: () => null,
});
